export const VALID_IDENTIFIER_RE = /^[A-Za-z_][A-Za-z0-9_]*$/;

const isQuoted = (facet: string) => facet.length >= 2 && facet.startsWith('"') && facet.endsWith('"');
const quote = (facet: string) => JSON.stringify(facet);
const shouldQuote = (facet: string) => !VALID_IDENTIFIER_RE.test(facet) && !isQuoted(facet);

export const normalizeFacet = (facet: string): string => {
  if (shouldQuote(facet)) return quote(facet);
  return facet;
};
